// Ohut HTTP API -kerros Varauskalenterit.js -funktioille.
// Perustuu REACT_APP_API_URL -ympäristömuuttujaan (esim. https://<region>-<project>.cloudfunctions.net)

const API_BASE = process.env.REACT_APP_API_URL;

/** Listaa kaikki varauskalenterit (backend: getVarauskalenterit) */
export async function listAllCalendars() {
  const url = `${API_BASE}/getVarauskalenterit`;
  const res = await fetch(url);
  if (!res.ok) throw new Error('getVarauskalenterit failed');
  return await res.json(); // [{id, ...}]
}

/** UUSI: Listaa vain ne kalenterit, joissa talonyhtiöt sisältää companyId:n */
export async function listCalendarsForCompany(companyId) {
  const all = await listAllCalendars();
  if (!companyId) return [];
  return (all || []).filter(c => Array.isArray(c?.talonyhtiöt) && c.talonyhtiöt.includes(companyId));
}

/** Hakee yksittäisen kalenterin */
export async function getCalendarById(calendarId) {
  const url = `${API_BASE}/getVarauskalenteriById?selectedVarauskalenteriId=${encodeURIComponent(calendarId)}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error('getVarauskalenteriById failed');
  return await res.json(); // {id, ...}
}

/** Päivittää varattavatajat-arrayn olemassa olevaan kalenteriin */
export async function updateCalendarVarattavatajat(calendarId, varattavatajatArray) {
  const url = `${API_BASE}/updateVarauskalenteri`;
  const payload = {
    varauskalenteriId: calendarId,
    varattavatajat: varattavatajatArray,
  };
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type':'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    let err;
    try { err = await res.json(); } catch {}
    throw new Error(err?.error || 'updateVarauskalenteri failed');
  }
  return await res.json(); // { message: ... }
}

/** Päivittää metatiedot (nimi, tyyppi, kuvaus, rajoitukset, sulut) olemassa olevaan kalenteriin */
export async function updateCalendarMeta(calendarId, patch) {
  const url = `${API_BASE}/updateVarauskalenteriMeta`;
  const payload = {
    varauskalenteriId: calendarId,
    patch, // saa sisältää myös { sulut: [...] }
  };
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type':'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    let err;
    try { err = await res.json(); } catch {}
    throw new Error(err?.error || 'updateVarauskalenteriMeta failed');
  }
  return await res.json(); // { message: ... }
}

/** Luo uuden kalenterin (sis. varattavatajat + sulut) */
export async function createCalendar(payload) {
  // payload: { nimi, tyyppi, kuvaus, rajoitukset, varattavatajatArray, talonyhtiöt, blocks? }
  const res = await fetch(`${API_BASE}/createVarauskalenteri`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload), // voi sisältää blocks -> backendissä 'sulut'
  });
  if (!res.ok) throw new Error('createCalendar failed');
  return res.json(); // odotetaan { id: '...' }
}
